<template>
  <div class="userInfo">
    <div v-if="otherUserInfo.companyName" class="companyBox">
      <div class="companyInfo">
        <img
          class="companyLogo"
          :src="(otherUserInfo.companyLogo || DEFAULTS_AVATAR_BIG) + '?x-oss-process=image/resize,m_fixed,h_64,w_64'"
          :onerror="`this.src='${DEFAULTS_AVATAR_BIG}';this.οnerrοr=null`"
        />
        <span class="companyName" @click.stop="toHomePage">{{ otherUserInfo.companyName }}</span>
        <a-icon
          type="right-circle"
          theme="filled"
          style="color: #e0e0e4"
          class="companyIcon"
          @click.stop="toHomePage"
        />
      </div>
    </div>

    <div class="purchaseIdentity">
      <div v-if="otherUserInfo.purchaserFlag === 1" class="buyer">
        {{ $t('采购商') }}
      </div>
      <div v-if="otherUserInfo.supplierFlag === 1" class="supplier">
        {{ $t('供应商') }}
      </div>
      <div v-if="otherUserInfo.allianceFlag === 1" class="alliance">
        {{ $t('加盟商') }}
      </div>
      <div v-if="otherUserInfo.brandFlag === 1" class="brand">
        {{ $t('品牌商') }}
      </div>
    </div>

    <!-- 用户名片 -->
    <div v-if="otherUserInfo.roleId" class="userCard">
      <!-- 新版本的名片 -->
      <div class="tip">
        <a-icon type="user" :style="{ fontSize: '16px' }" />
        <span>{{ $t('Ta的名片') }}</span>
      </div>
      <div class="nameCardStyle">
        <div class="nameCardTop">
          <img
            :src="
              ((otherUserInfo && (otherUserInfo.cardAvatar || otherUserInfo.memberAvatar)) || DEFAULTS_AVATAR_BIG) +
              '?x-oss-process=image/resize,m_fixed,h_64,w_64'
            "
            :onerror="`this.src='${DEFAULTS_AVATAR_BIG}';this.οnerrοr=null`"
          />
          <div>
            <div class="name">
              {{
                otherUserInfo.memberCardContactName ||
                otherUserInfo.memberUserName ||
                otherUserInfo.contact ||
                otherUserInfo.userName
              }}
            </div>
            <div class="post">
              {{ otherUserInfo.post }}
            </div>
          </div>
        </div>
        <div class="userCont">
          <div v-if="otherUserInfo.companyName" class="row">
            <i class="icon iconfont iconqiye2 item-icon" :title="$t('企业')" /><span class="item-text">{{
              otherUserInfo.companyName
            }}</span>
          </div>
          <div
            v-if="
              otherUserInfo.phone ||
              otherUserInfo.memberCardPhone ||
              otherUserInfo.fixedphone ||
              otherUserInfo.memberCardFixedPhone
            "
            class="row"
          >
            <i class="icon iconfont icondianhua item-icon" :title="$t('电话')" /><span
              class="item-text"
              :title="`${otherUserInfo.phonearea} ${otherUserInfo.phone || otherUserInfo.memberCardPhone} ${
                otherUserInfo.fixedphone || otherUserInfo.memberCardFixedPhone
              }`"
            >
              <template v-if="otherUserInfo.phone || otherUserInfo.memberCardPhone">
                <!-- {{ otherUserInfo.phonearea + ' ' || '+86 '}} -->
                {{
                  otherUserInfo.phonearea
                    ? otherUserInfo.phonearea + ' ' + (otherUserInfo.phone || otherUserInfo.memberCardPhone)
                    : '+86 ' + (otherUserInfo.phone || otherUserInfo.memberCardPhone)
                }}
              </template>
              <br
                v-if="
                  (otherUserInfo.phone || otherUserInfo.memberCardPhone) &&
                  (otherUserInfo.fixedphone || otherUserInfo.memberCardFixedPhone)
                "
              />
              <template v-if="otherUserInfo.fixedphone || otherUserInfo.memberCardFixedPhone">{{
                otherUserInfo.fixedphone || otherUserInfo.memberCardFixedPhone
              }}</template>
            </span>
          </div>
          <div v-if="otherUserInfo.email" class="row">
            <i class="icon iconfont iconyouxiang item-icon" :title="$t('邮箱')" /><span
              class="item-text"
              :title="otherUserInfo.email"
              >{{ otherUserInfo.email }}</span
            >
          </div>

          <div v-if="otherUserInfo.address" class="row">
            <i class="icon iconfont iconweizhidingwei item-icon" :title="$t('地址')" />
            <span class="item-text address" :title="region + otherUserInfo.address"
              >{{ region }}{{ otherUserInfo.address }}</span
            >
          </div>
        </div>
      </div>
      <div
        v-if="!spinning && (otherUserInfo.companyId || otherUserInfo.companyName)"
        class="userCardBtns"
        :style="$store.state.locale === 'en' ? 'flex-wrap: wrap' : ''"
      >
        <ShareLinkTooltip
          :share-type="
            otherUserInfo.companyFlag === System.Identity.Company ||
            (!otherUserInfo.companyId && !otherUserInfo.companyName)
              ? System.ShareType.MemberCardCompanyShare
              : System.ShareType.MemberCardShare
          "
          :share-target-member-code="nowId"
          :share-param="nowId"
          placement="topLeft"
        >
          <a-button class="shareBtn">
            {{ $t('立即分享') }}
          </a-button>
        </ShareLinkTooltip>

        <a-button style="min-width: 130px; height: 36px" type="primary" @click="getApplyCard">
          {{ $t('交换云展') }}
        </a-button>
      </div>
    </div>

    <div v-if="!otherUserInfo.companyName && !otherUserInfo.roleId" class="emptyBox">
      <img :src="IMAGE_GRAY_CONTENT" :alt="$t('无内容')" />
      {{ $t('暂无对方基本信息') }}
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { getSwapCard } from '@/api/memberCenter/namecard'

// components
import ShareLinkTooltip from '@/components/Share/ShareLinkTooltip.vue'

// utils
import { arrDataJoinString } from '@/utils/data'
import { DEFAULTS_AVATAR, DEFAULTS_AVATAR_BIG, IMAGE_GRAY_CONTENT } from '@/const/image'

import { System } from '@/const/constConfig'

export default {
  name: 'ChatCompanyInfo',
  components: {
    ShareLinkTooltip,
  },
  props: {
    spinning: {
      type: Boolean,
      default: false,
    },
    showHomeBtn: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      System,
      DEFAULTS_AVATAR,
      DEFAULTS_AVATAR_BIG,
      IMAGE_GRAY_CONTENT,
    }
  },
  computed: {
    ...mapGetters({
      otherUserInfo: 'chat/otherUserInfo',
    }),
    region() {
      const { otherUserInfo } = this
      return arrDataJoinString([
        // otherUserInfo.continentName,
        otherUserInfo.countryName,
        otherUserInfo.stateName,
        otherUserInfo.cityName,
        otherUserInfo.regionName,
      ])
    },
    // 当前用户的id
    nowId() {
      return (
        this.otherUserInfo.memunicode ||
        this.otherUserInfo.memUnicode ||
        this.otherUserInfo.huanxinId ||
        this.otherUserInfo.id
      )
    },
    rules() {
      return {
        contact: this.customRulesString({
          message: this.$t('联系人姓名不能为空'),
          max: 20,
        }),
        phone: this.rulesPhoneNumberOptional,
        fixedphone: this.customRulesString({
          rules: {
            required: false,
          },
          max: 20,
          maxMessage: this.$t('最多填写20个数字'),
        }),
        email: this.rulesEmail,
        post: this.customRulesString({
          message: this.$t('岗位不能为空'),
          max: 30,
        }),
        descriptions: this.customRulesString({
          rules: {
            required: false,
          },
          max: 500,
        }),
      }
    },
  },
  mounted() {
    console.log('otherUserInfo', this.otherUserInfo)
    if (!this.otherUserInfo.memunicode && this.otherUserInfo.memUnicode) {
      this.otherUserInfo.memunicode = this.otherUserInfo.memUnicode
    }
  },
  methods: {
    // 交换云展
    async getApplyCard() {
      const that = this
      this.applyCardLoading = true
      console.log('交换云展', this.nowId, this.otherUserInfo)
      const { code, data, msg } = await getSwapCard({
        memberUnicode: this.nowId,
      })
      this.applyCardLoading = false
      if (code === 0) {
        this.$message.success(data)
      } else if (code === 4001) {
        this.$warning({
          title: this.$t('提示'),
          closable: true,
          maskClosable: true,
          content: this.$t(msg),
          okText: this.$t('去完善名片'),
          onOk: () => {
            that.$router.push(`${this.$store.getters.getConsolePath}/card`)
            that.$store.commit('chat/switchChatModelShow', false)
          },
        })
      } else if (code === 1109 || code === 20008 || code === 20009 || code === 20010 || code === 20011) {
        this.$warning({
          title: this.$t('提示'),
          closable: true,
          maskClosable: true,
          content: this.$t(msg),
          okText: this.$t('去升级'),
          onOk: () => {
            that.$router.push('/upgradevip')
            that.$store.commit('chat/switchChatModelShow', false)
          },
        })
      }
    },
    toHomePage() {
      if (!this.nowId) {
        return
      }

      this.$utils.toOuterLink(`/${this.nowId}`)
    },
  },
}
</script>
<style lang="scss" scoped>
.userInfo {
  position: relative;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255);
  border-left: 1px solid rgba(0, 0, 0, 0.05);

  //box-shadow: inset 0px 12px 10px -15px rgb(0 0 0 / 30%);
  .companyBox {
    position: relative;
    width: 100%;
    padding: 0 20px;

    .companyInfo {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 50px;
      margin: 20px 0;

      .companyLogo {
        width: 50px;
        height: 50px;
        border-radius: 6px;
      }

      .companyName {
        @include text-ellipsis(3);
        width: 180px;
        font-size: 18px;
        // font-weight: bold;
        color: #333333;
        cursor: pointer;
      }

      .companyIcon {
        font-size: 20px;
        cursor: pointer;
      }
    }
  }

  .userCard {
    position: relative;
    width: 100%;
    padding: 20px;

    > .tip {
      margin-bottom: 8px;

      span {
        font-size: 16px;
        font-weight: bold;
        color: #333333;
      }
    }

    > .nameCardStyle {
      padding: 20px 20px 0 20px;
      width: 100%;
      border: 1px solid #ff6600;
      box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.08);
      border-radius: 6px;

      // cursor: pointer;
      .nameCardTop {
        display: flex;
        border-bottom: 1px solid #e4e4e8;
        padding-bottom: 20px;

        > img {
          border-radius: 4px;
          margin-right: 20px;
          width: 64px;
          height: 64px;
        }

        > div {
          max-width: 130px;

          .name {
            @include text-ellipsis(2);
            font-size: 18px;
            color: #101113;
          }

          .post {
            @include text-ellipsis(2);
            font-size: 16px;
            color: #767779;
            line-height: 24px;
          }
        }
      }

      .userCont {
        padding: 16px 0;
        word-break: break-all;

        .row {
          display: flex;
          margin: 4px 0;

          &:nth-of-type(1) {
            margin-top: 0;
          }

          &:nth-last-of-type(1) {
            margin-bottom: 0;
          }
        }

        .item-icon {
          color: #dddddd;
          margin-right: 10px;
        }

        .address {
          @include text-ellipsis(3);
        }
      }
    }

    > .userCardBtns {
      margin-top: 20px;
      display: flex;
      justify-content: center;

      .shareBtn {
        min-width: 130px;
        height: 36px;
        color: #ff6600;
        border: 1px solid #ff6600;
        margin-right: 2px;
        margin-bottom: 20px;
      }
    }
  }

  .emptyBox {
    position: relative;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 400;
    color: #aaabad;
    width: 100%;
    height: 100%;
    align-items: center;

    > img {
      width: 80%;
      margin-bottom: 20px;
    }

    font-size: 16px;
    font-weight: 400;
    color: #aaabad;
  }
}

.purchaseIdentity {
  position: relative;
  width: 100%;
  padding: 8px 20px 0;
  display: flex;

  > div {
    padding: 0 2px;
    height: 18px;
    line-height: 18px;
    border-radius: 2px;
    display: inline-block;
    margin-right: 4px;
    color: #ffffff;
  }

  .buyer {
    background: #3386f1;
    border-radius: 2px;
    display: inline-block;
  }

  .supplier {
    background: #ff6600;
  }

  .alliance {
    background: #f54342;
  }

  .brand {
    background: #485aeb;
  }
}
</style>
